import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import Image from 'next/image'
import { FC, useEffect, useState } from 'react'

import { SafeNumber } from '../../../types'

const LNS_METADATA_URL: Record<number, string> = {
  [ChainId.SMARTBCH]: 'https://metadata.bch.domains/smartbch',
  [ChainId.SMARTBCH_TESTNET]: 'https://metadata.bch.domains/smartbch',
}

export interface IconProps {
  chainId: ChainId
  ENSName: string | null
  width?: SafeNumber
  height?: SafeNumber
}

export const Avatar: FC<IconProps> = ({ chainId, ENSName, width = '28', height = '28' }) => {
  const fallbackAvatar = '/images/main/icon/icon-144x144.png'
  const src = ENSName ? `${LNS_METADATA_URL[chainId]}/avatar/${ENSName}` : fallbackAvatar
  // const src = 'https://metadata.bch.domains/smartbch/avatar/alberdioni8406.bch'
  const [error, setError] = useState(false)
  useEffect(() => {
    setError(false)
  }, [src])
  return (
    <Image
      className="select-none"
      src={error ? fallbackAvatar : src}
      onErrorCapture={() => setError(true)}
      alt={'Avatar'}
      key={src}
      placeholder="blur"
      blurDataURL={fallbackAvatar}
      width={width}
      height={height}
    />
  )
}
